import React, { useEffect, useState } from 'react';
import { handleCallback } from '../lib/auth';
import { useT } from '../lib/LanguageContext';

/** Handles the redirect from Cognito Hosted UI:
 *  Cognito sends ?code=...&state=...; oidc-client-ts exchanges it for tokens,
 *  then we redirect back to "/". */
export default function AuthCallback() {
  const t = useT();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        await handleCallback();
        // Clean URL + go home.
        window.history.replaceState({}, document.title, '/');
        window.location.replace('/');
      } catch (e) {
        setError(e?.message || String(e));
      }
    })();
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-keep-page text-keep-text px-6"
      data-testid="auth-callback"
    >
      <div className="max-w-md w-full text-center space-y-3">
        {error ? (
          <>
            <h1 className="text-2xl font-medium">{t('authCallback.failed')}</h1>
            <p className="text-keep-textMuted text-sm break-words">{error}</p>
            <a
              href="/"
              className="inline-block mt-4 px-4 py-2 rounded-full bg-keep-accent text-keep-onAccent text-sm"
            >
              {t('authCallback.backHome')}
            </a>
          </>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto border-2 border-keep-accent border-t-transparent rounded-full animate-spin" />
            <p className="text-keep-textMuted text-sm">{t('authCallback.finishing')}</p>
          </>
        )}
      </div>
    </div>
  );
}
